// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  .v-validate-pristine--style, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  v-tag {
    max-width: var(--tag-max-width);
  }
  v-autoComplete .p-autocomplete {
    display: flex;
    border: var(--tag-border);
    border-radius: var(--tag-border-radius);
  }
  v-autoComplete .p-autocomplete .p-autocomplete-multiple-container {
    display: flex;
    flex-wrap: wrap;
    padding: var(--tag-padding) !important;
    gap: var(--tag-gap);
    border: none;
  }
  v-autoComplete .p-autocomplete .p-autocomplete-dropdown.p-button {
    flex-shrink: 0;
    width: var(--tag-width);
    background: var(--tag-autocomplete-dropdown-background);
    border-color: var(--tag-border-color);
    color: var(--tag-color);
  }
  v-autoComplete .p-autocomplete .p-autocomplete-input-token {
    flex: 100%;
    margin: var(--tag-margin);
  }
  v-autoComplete .p-autocomplete .p-autocomplete-input-token:not(:first-child) {
    margin-top: var(--tag-margin-top);
    border-top: var(--tag-border-top);
  }
  v-autoComplete .p-autocomplete .p-autocomplete-input-chip:last-child {
    width: 100%;
  }
  v-autoComplete .v-component-container:focus, v-autoComplete .v-component-container input:focus {
    box-shadow: none;
  }
  v-autoComplete .v-component-container input:hover {
    border: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/validation.sass","webpack://./src/app/modules/wrappers/lib/tag/tag.component.sass"],"names":[],"mappings":"AAAA;EACI;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;ECGN;EDDE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;ECGN;EDGE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECDN;AACF;AAlBA;EACI;IACI,+BAAA;EAoBN;EAlBM;IACI,aAAA;IACA,yBAAA;IACA,uCAAA;EAoBV;EAnBU;IACI,aAAA;IACA,eAAA;IACA,sCAAA;IACA,mBAAA;IACA,YAAA;EAqBd;EApBU;IACI,cAAA;IACA,uBAAA;IACA,uDAAA;IACA,qCAAA;IACA,uBAAA;EAsBd;EArBU;IACI,UAAA;IACA,yBAAA;EAuBd;EAtBc;IACI,iCAAA;IACA,iCAAA;EAwBlB;EAvBU;IACI,WAAA;EAyBd;EAxBM;IACI,gBAAA;EA0BV;EAzBM;IACI,YAAA;EA2BV;AACF","sourcesContent":["@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none","@use '../validation.sass'\n@layer vierkant\n    v-tag\n        max-width: var(--tag-max-width)\n    v-autoComplete\n        .p-autocomplete \n            display: flex\n            border: var(--tag-border)\n            border-radius: var(--tag-border-radius)\n            .p-autocomplete-multiple-container \n                display: flex\n                flex-wrap: wrap\n                padding: var(--tag-padding) !important\n                gap: var(--tag-gap)\n                border: none\n            .p-autocomplete-dropdown.p-button\n                flex-shrink: 0\n                width: var(--tag-width)\n                background: var(--tag-autocomplete-dropdown-background)\n                border-color: var(--tag-border-color)\n                color: var(--tag-color)\n            .p-autocomplete-input-token\n                flex: 100%\n                margin: var(--tag-margin)\n                &:not(:first-child)\n                    margin-top: var(--tag-margin-top)\n                    border-top: var(--tag-border-top)\n            .p-autocomplete-input-chip:last-child\n                width: 100%\n        .v-component-container:focus, .v-component-container input:focus\n            box-shadow: none\n        .v-component-container input:hover\n            border: none"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
